import { useState } from 'react';
import { Slider, TextField } from '@nexelem/components';
import { useController } from 'react-hook-form';
import { ParameterLabel } from './ParameterLabel';

type RangeParameterProps = {
  name: string;
  label: string;
  from: number;
  to: number;
};

export const RangeParameter = ({ name, label, from, to }: RangeParameterProps) => {
  const { field, fieldState } = useController({ name });
  const hasError = !!fieldState.error;

  const clamp = (value: number) => Math.min(to, Math.max(from, value));
  const fieldValue = typeof field.value === 'number' && Number.isFinite(field.value) ? field.value : undefined;

  const [dragValue, setDragValue] = useState<number | null>(null);
  const sliderValue = dragValue ?? (fieldValue !== undefined ? clamp(fieldValue) : from);

  return (
    <div className="flex items-center gap-6 min-h-8">
      <ParameterLabel label={label} />
      <Slider
        className="w-50 shrink-0"
        max={to}
        min={from}
        step={1}
        value={[sliderValue]}
        onValueChange={([next]) => setDragValue(next)}
        onValueCommit={([next]) => {
          setDragValue(null);
          field.onChange(next);
        }}
      />
      <TextField
        className="w-12 shrink-0"
        inputClassName="text-center"
        showErrorBorder={hasError}
        size="small"
        type="number"
        value={dragValue ?? fieldValue ?? ''}
        onChange={(next: string | number) => field.onChange(next === '' ? undefined : Number(next))}
        onBlur={() => {
          if (fieldValue !== undefined) {
            field.onChange(clamp(fieldValue));
          }
          field.onBlur();
        }}
      />
    </div>
  );
};
